const INITIAL_STATE = {
	registro: {},
	modoTela: 'lista',
	aguardando: false,
	lista: [],
	listaSelect: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'COMPRA_STATUS_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'COMPRA_STATUS_SET_AGUARDANDO':
			return { ...state,
				aguardando: action.payload
			};

        case 'COMPRA_STATUS_LISTADO':
            return {
				...state,
				lista: action.payload.data,
				listaSelect: action.payload.data.map(item => ({
                    id: item.id,
                    valor: item.nome,
					status_possiveis: item.status_possiveis
                }))
			};

        default:
            return state;
    }
}
